import { defaultFeatureFlags, FeatureFlags } from './featureFlags';

/**
 * Permission names gated by feature flags — hidden in CMS role UI when the flag is off.
 * Matches Permission.Name (e.g. CreateParking, ViewHtmlApplet).
 */
const FEATURE_PERMISSION_MATCHERS: {
  flag: keyof FeatureFlags;
  nameIncludes: string;
}[] = [
  { flag: 'parkingEnabled', nameIncludes: 'Parking' },
  { flag: 'htmlAppletsEnabled', nameIncludes: 'HtmlApplet' },
  { flag: 'reportsEnabled', nameIncludes: 'Report' },
  { flag: 'rssEnabled', nameIncludes: 'Rss' },
  { flag: 'pushEnabled', nameIncludes: 'Notification' },
  { flag: 'pushEnabled', nameIncludes: 'Push' },
  { flag: 'cityDirectoryEnabled', nameIncludes: 'MapObject' },
  { flag: 'cityDirectoryEnabled', nameIncludes: 'Official' },
  { flag: 'appThemeEnabled', nameIncludes: 'MobileApplicationTheme' },
];

function isPermissionVisibleForFlags(
  permissionName: string | null | undefined,
  flags: FeatureFlags | null | undefined
): boolean {
  if (!permissionName) return true;
  const f = flags ?? defaultFeatureFlags;

  for (const rule of FEATURE_PERMISSION_MATCHERS) {
    if (permissionName.includes(rule.nameIncludes) && !f[rule.flag]) {
      return false;
    }
  }
  return true;
}

export function filterPermissionsByFeatureFlags<
  T extends { name?: string | null }
>(permissions: T[], flags: FeatureFlags | null | undefined): T[] {
  return permissions.filter((p) =>
    isPermissionVisibleForFlags(p.name, flags)
  );
}
